import { useState, useEffect } from 'react'
import { getTenant, getToken } from '../../utils'
import PubSub from 'pubsub-js'
import PDFControls from './PDFControls'
import './PDFFrames.css'

export default function PDFFrames() {
  console.log('PDFControls rendered')
  const tenant = getTenant()
  const params = new URLSearchParams(window.location.search)
  console.log('78900000000000000000000000000000000000000',params)
  const [jwt, setJwt] = useState(params.get('jwt'))
  const searchId = params.get('searchId')
  const searchName = params.get('searchName')
  const inputs = params.get('inputs')

  const [pdfControls, setPdfControls] = useState(null)  //state so that it forces refresh of the iframe

  useEffect(() => {
    function handleRefresh(msg, data) {
      console.log(`EVENT RECEIVED (Refresh Button): ${msg}`, data)
      function tokenSuccess(newjwt) {
        setJwt(newjwt)
        setPdfControls(JSON.stringify(data))
      }
      function tokenError(error) {
        setPdfControls(JSON.stringify(data))
      }
      getToken(tokenSuccess, tokenError)
    }
    const eventName = 'PDF Refresh Button'
    const token = PubSub.subscribe(eventName, handleRefresh)
    return function cleanup() {
      PubSub.unsubscribe(token)
    }
  })

  return (
    <div className="frameContainer" height="100%">
      <PDFControls />
      <iframe title="bottom" width="100%" height="95%" src={`${process.env.REACT_APP_SERVER}/pdf/${tenant}/${searchName}.pdf?jwt=${jwt}&searchId=${searchId}&inputs=${inputs}&pdfControls=${pdfControls}`} ></iframe>
    </div>
  )
}